export const userProfileHelpers = {
  getDefaultPanDetails,
  getAllValidPanDetails,
  indianNumberWithCommas
}

function getDefaultPanDetails(validPans, panDetailsList) {
  if(panDetailsList) {
    var defaultPanDetails = panDetailsList.filter(function(panDetails) {
      return panDetails.pan && panDetails.pan === validPans.default;
    });
    return defaultPanDetails;
  }

  return {};
}

function getAllValidPanDetails(validPans, panDetailsList) {
  // if(panDetailsList) {
  //   var validPanDetails = panDetailsList.filter(function(panDetails) {
  //     for(var index in validPans) {
  //       var pan = validPans[index]; 
  //       if(pan.pan == panDetails.pan && pan.active) {
  //         return true;
  //       }
  //     }
  //     return false;
  //   });

  //   return validPanDetails;
  // }

  if (validPans) {
    var validPanDetails = validPans.filter((pan) => {
      if (pan.active) {
        panDetailsList.forEach(element => {
          if (pan.pan === element.pan) {
            pan = {...pan,...element};
          }
        });
        return true;
      }
    });
    return validPanDetails;
  }
  return [];
}

function indianNumberWithCommas(x) {
  x=x.toString();
  var afterPoint = '';
  if(x.indexOf('.') > 0)
     afterPoint = x.substring(x.indexOf('.'),x.length);
  x = Math.floor(x);
  x=x.toString();
  var lastThree = x.substring(x.length-3);
  var otherNumbers = x.substring(0,x.length-3);
  if(otherNumbers !== '')
      lastThree = ',' + lastThree;
  var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
  return res;
}